<script lang="ts">
    import {Component, mixins, Prop, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {ActivityStoreMixin} from '@/mixins/ActivityStoreMixin.vue'
    import {ACTIVITY} from '@/utils/activities/activities-const'
    import {isOwnProduct} from '@/utils/api-helpers'
    import {ActivityOrderSummaryMixin} from '@/components/activities/mixins/ActivityOrderSummaryMixin.vue'
    import {ActivityBookingFieldsMixin} from '@/components/activities/booking/mixins/ActivityBookingFieldsMixin.vue'
    import BookingPageMixin from '~src/mixins/BookingPageMixin.vue'
    import {callComponentMethod} from '~/utils/vue-class-helpers'

    @Component({mixins: [BookingPageBase]})
    export class ActivityBookingPageLayout extends mixins(
        ActivityStoreMixin,
        ActivityOrderSummaryMixin,
        ActivityBookingFieldsMixin
    ) {
        @Prop({required: true}) product

        prepareBookRequest(specifiedTouristBookingFields, includeOptionalTourists = false) {
            const startTime = this.offer.startTimes?.[0]
            const language = this.offer.languages?.[0] || null

            const prepareBookRequest = callComponentMethod(
                this,
                BookingPageMixin,
                'prepareBookRequest',
                specifiedTouristBookingFields,
                includeOptionalTourists
                // ...(startTime && {startTime})
            )

            if (startTime) {
                prepareBookRequest.startTime = startTime
            }

            if (language) {
                prepareBookRequest.language = language
            }

            return this.filterPrepareBookRequest(prepareBookRequest)
        }

        get productSearchPageName() {
            return 'activities'
        }

        get productConfirmationPageName() {
            return 'activityConfirmation'
        }

        get productName() {
            return ACTIVITY
        }

        get productBookingPageName() {
            return 'activityBooking'
        }

        get corporatePolicyType() {
            return 'activity'
        }

        get touristToken() {
            return 'guest'
        }

        get startDate() {
            return this.offer.date
        }

        get showAddOns() {
            return isOwnProduct(this.product.supplierId)
        }
    }

    export default {...toNative(ActivityBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
